// extracted by mini-css-extract-plugin
export default {"green":"#73c06b","tabs":"Custom_tabs__qH2rj","tab":"Custom_tab__yxQiB"};